import { useState, useEffect } from 'react';
import axios from 'axios';
import { Routes, Route, useLocation } from 'react-router-dom';
import { ToastProvider } from './components/ToastContext';
import countriesRegistry from 'i18n-iso-countries';
import './styles/App.css';

// Komponenty interfejsu
import Navbar from './components/layout/Navbar';
import HomeGlobe from './components/globe/HomeGlobe';
import Features from './components/layout/Features';
import Footer from './components/layout/Footer';

// Podstrony
import SignUp from './components/auth/SignUp';
import SignIn from './components/auth/SignIn';
import Trip from './components/trips/Trip';
import RegisterVerificationWindow from './components/auth/RegisterVerificationWindow';
import EmailVerifier from './components/auth/EmailVerifier';
import Globe from './components/globe/Globe';
import NewTripEditor from './components/trips/NewTripEditor';
import UpdateTrip from './components/trips/UpdateTrip';
import ForgotPassword from './components/auth/ForgotPassword';
import NewPassword from './components/auth/NewPassword';
import ChangedPasswordVerifier from './components/auth/ChangedPasswordVerifier';
import EmailVerificationWindow from './components/auth/EmailVerificationWindow';
import ContactForm from './components/common/ContactForm';
import AccountSettings from './components/user/AccountSettings';
import DeleteAccountConfirmation from './components/user/DeleteAccountConfiramtion';
import GuestInfoWindow from './components/common/GuestInfoWindow';
import AboutMe from './components/common/AboutMe';

import ReactGA from 'react-ga4';
ReactGA.initialize('G-DR5ET69433');

// Pomocniczy komponent dla Strony Głównym (żeby globus i sekcje były tylko pod adresem "/")
function HomePage() {
  return (
    <>
      <HomeGlobe />
      <Features />
      <Footer />
    </>
  );
}

export default function App() {
  const API_URL = process.env.REACT_APP_API_URL;
  
  const location = useLocation();
  const [loggedIn, setLoggedIn] = useState(!!localStorage.getItem("loggedIn"));
  const userId = localStorage.getItem("userId")
  countriesRegistry.registerLocale(require('i18n-iso-countries/langs/pl.json'));

  const [userCountries, setUserCountries] = useState([]);

  useEffect(() => {
    const checkAuth = () => {
      setLoggedIn(!!localStorage.getItem("loggedIn"));
    };

    window.addEventListener("storage", checkAuth);
    return () => window.removeEventListener("storage", checkAuth);
  }, []);

  const handleLogout = (e) => {
    e?.preventDefault(); // ? zabezpiecza przed brakiem parametru
    localStorage.clear();
    setLoggedIn(false);
    window.location.href = "/";
  };

  useEffect(() => {
    if (loggedIn) {
      axios
        .get(`${API_URL}/trips/visited/${userId}`)
        .then(response => {
          const numericIds = response.data
            .map(isoCode => {
              const numCode = countriesRegistry.alpha2ToNumeric(isoCode);
              return String(Number(numCode));
            })
            .filter(Boolean) //usuwa puste wartości

          setUserCountries(numericIds)
          localStorage.setItem("visitedCountriesNo", numericIds.length);
        })
        .catch(error => {
          console.error("Błąd pobierania odwiedzonych krajów:", error);
        });
    } else {
      setUserCountries([]); // czyszczenie danych dla niezalogowanego
    }
  }, [loggedIn]);

  //GA
  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname + location.search
    });
  }, [location]);

  return (
    <ToastProvider>
      <div className="app-container">
        {/* Navbar jest na każdej podstronie */}
        <Navbar loggedIn={loggedIn} onLogout={handleLogout} />

        {/* Zmienna treść w zależności od adresu URL */}
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/rejestracja" element={<SignUp />} />
          <Route path="/logowanie" element={<SignIn setLoggedIn={setLoggedIn} />} />
          <Route path="/dolacz" element={<GuestInfoWindow />} />
          <Route path="/weryfikacja-rejestracji" element={<RegisterVerificationWindow />} />
          <Route path="/weryfikacja" element={<EmailVerifier />} />
          <Route path="/wpis" element={<Trip />} />
          <Route path="/nowy-wpis" element={<NewTripEditor />} />
          <Route path="/globus" element={<Globe width={950} height={950} />} />
          <Route path="/edytuj-wpis" element={<UpdateTrip />} />
          <Route path="/reset-hasla" element={<ForgotPassword />} />
          <Route path="/weryfikacja-email" element={<EmailVerificationWindow />} />
          <Route path="/nowe-haslo" element={<NewPassword />} />
          <Route path="/zmienione-haslo" element={<ChangedPasswordVerifier />} />
          <Route path="/formularz-zgloszeniowy" element={<ContactForm />} />
          <Route path="/moje-konto" element={<AccountSettings />} />
          <Route path="/delete-account" element={<DeleteAccountConfirmation />} />
          <Route path="/o-autorze" element={<AboutMe />} />
          <Route path="*" element={
            <div style={{ textAlign: 'center', padding: '50px' }}>
              <h2>404 - Strona nie została znaleziona</h2>
              <p>Przepraszamy, podany adres nie istnieje.</p>
            </div>
          } />
        </Routes>
      </div>
    </ToastProvider>
  );
}